import { useContext } from "react";
import MenuContext from "@/context/Menu";

const Menu = () => {
  const context = useContext(MenuContext);

  return context;
};

export { Menu as useMenu };
